var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-12"},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('b',{domProps:{"textContent":_vm._s(_vm.$lang.add_ticket_by_operator)}})]),_c('ticketFrom',{ref:"ticketForm",attrs:{"byOperator":true},on:{"cancel":_vm.handleBack,"submit":_vm.save,"responseCode":_vm.setResponseCode}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }